import { useEffect } from "react";

const SITE = "SportScience Academy";

const setMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export const useSeo = ({ title, description, image, lang = "el", noindex = false }) => {
  useEffect(() => {
    const fullTitle = title ? (title.includes(SITE) ? title : `${title} | ${SITE}`) : SITE;
    document.title = fullTitle;
    document.documentElement.setAttribute("lang", lang === "en" ? "en" : "el");

    const url = window.location.origin + window.location.pathname;
    const raw = image || "/og-image.jpg";
    const img = /^https?:\/\//.test(raw) ? raw : window.location.origin + (raw.startsWith("/") ? raw : `/${raw}`);

    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", img);
    setMeta("property", "og:site_name", SITE);
    setMeta("property", "og:locale", lang === "en" ? "en_US" : "el_GR");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", img);
    setLink("canonical", url);
  }, [title, description, image, lang, noindex]);
};

export default useSeo;
